module.exports = __webpack_public_path__ + "static/media/corporate-services-img86.503c3f27.jpg";